import { useState } from "react";
import { ExternalLink, X } from "lucide-react";

const URL = "https://mabuhayparish.org";

export function ParishWebsiteBadge() {
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("parish-badge-hidden") === "1");
  if (hidden) {
    return (
      <button data-testid="parish-website-reopen" onClick={() => { sessionStorage.removeItem("parish-badge-hidden"); setHidden(false); }}
        className="fixed bottom-4 left-4 z-40 h-9 w-9 rounded-full bg-white/90 shadow-md ring-1 ring-[#C9A227]/50 overflow-hidden opacity-70 hover:opacity-100 transition-opacity print:hidden"
        aria-label="Show parish website link"><img src="/parish-logo.png" alt="" className="h-full w-full object-cover" /></button>
    );
  }
  return (
    <div className="fixed bottom-3 left-3 sm:bottom-4 sm:left-4 z-40 print:hidden parish-badge opacity-90 hover:opacity-100 transition-opacity" data-testid="parish-website-badge">
      <a href={URL} target="_blank" rel="noopener noreferrer" data-testid="parish-website-link"
        className="group flex items-center gap-0 hover:gap-3 rounded-full bg-[#5C4033]/95 backdrop-blur-md pl-1 pr-1 hover:pr-4 py-1 shadow-lg ring-1 ring-[#C9A227]/60 text-white transition-[gap,padding,box-shadow] duration-300 hover:shadow-xl"
        aria-label="Visit the Saint Francis of Assisi Parish website">
        <span className="relative h-9 w-9 sm:h-11 sm:w-11 shrink-0 rounded-full bg-white ring-2 ring-[#C9A227] overflow-hidden">
          <img src="/parish-logo.png" alt="Parish seal" className="h-full w-full object-cover" />
        </span>
        <span className="max-w-0 group-hover:max-w-[16rem] group-focus-visible:max-w-[16rem] overflow-hidden whitespace-nowrap transition-[max-width] duration-300 ease-out">
          <span className="block text-[10px] uppercase tracking-[0.18em] text-[#E9D79A]">Visit our parish website</span>
          <span className="flex items-center gap-1 font-serif text-sm font-bold">mabuhayparish.org <ExternalLink className="h-3.5 w-3.5" /></span>
        </span>
      </a>
      <button data-testid="parish-website-hide" onClick={() => { sessionStorage.setItem("parish-badge-hidden", "1"); setHidden(true); }}
        className="absolute -top-1.5 -right-1.5 h-5 w-5 rounded-full bg-white text-[#5C4033] shadow ring-1 ring-[#E4DACD] grid place-items-center opacity-0 hover:opacity-100 focus:opacity-100 [.parish-badge:hover_&]:opacity-100 transition-opacity"
        aria-label="Hide parish website link"><X className="h-3 w-3" /></button>
    </div>
  );
}
